import { render, staticRenderFns } from "./OrderSingleSummary.vue?vue&type=template&id=a537f5d0&"
import script from "./OrderSingleSummary.vue?vue&type=script&lang=js&"
export * from "./OrderSingleSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports